import React from 'react';

const Save = (props: any) => (
  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 16.5V4C1 2.34315 2.34315 1 4 1H12C13.6569 1 15 2.34315 15 4V16.5C15.0002 16.6875 14.8954 16.8592 14.7288 16.945C14.5621 17.0308 14.3614 17.0161 14.209 16.907L8.291 12.679C8.11699 12.5545 7.88301 12.5545 7.709 12.679L1.791 16.906C1.63871 17.015 1.43829 17.0297 1.27168 16.9442C1.10508 16.8587 1.00022 16.6873 1 16.5Z"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
export default Save;
